"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserForDropdown = /** @class */ (function () {
    function UserForDropdown() {
    }
    return UserForDropdown;
}());
exports.default = UserForDropdown;
